const messages_vip = {
    zh: {
        title: 'VIP中心',
        navLink: 'Topup Center',
        login: '登录',
        logout: '登出',
        upgrade: '升级',
        purchase: '充值',
        upgradeVIP: '升级VIP',
        userLevel: '等级',
        userServer: '服务器',
        query: '查询',
        email: '电子邮箱',
        password: '密码',
        loading: '加载中',
        benefitsTitle: 'VIP权益',
        benefitsCondition: '首次充值',
        benefitsItem1: '充值返利',
        benefitsItem2: 'VIP专属奖励',
        benefitsItem3: '5%OFF每周折扣券(限时)',
        benefitsItem4: '10%OFF每周折扣券(限时)',
        vipInfoTitle: '说明',
        experienceTitle: '经验获取记录',
        tableTitle1: '时间(UTC+0)',
        tableTitle2: '获取途径',
        tableTitle3: '经验值',
        recordText1: '充值中心充值',
        recordText2: 'VIP等级重置',
        errorTips1: '登录失败',
        errorTips2: '暂无记录',
        htmlText1: '<p>1.您可以根据在官网充值中心上购买的C Coin数量升级您的VIP等级。</p><p>2.VIP等级的奖励C Coin和折扣券不能同时使用。奖励的C Coin不能用于升级您的VIP等级。</p><p>3.根据您当时的VIP等级，折扣券将于每周日（UTC）00:00发放。这些折扣券有效期至下周日（UTC）00:00。如果您在本周内升级您的VIP等级，您还将获得该等级的折扣券。</p><p>4.首次购买折扣不能与奖励C Coin或折扣券一起使用。首次购买折扣是默认情况下授予的。</p>',
        couponDescription4: '完成首次充值',
    },
    zh_tw: {
        title: 'VIP中心',
        navLink: 'Topup Center',
        login: '登入',
        logout: '登出',
        upgrade: '升級',
        purchase: '儲值',
        upgradeVIP: '升級VIP',
        userLevel: '等級',
        userServer: '伺服器',
        query: '查詢',
        email: '電子信箱',
        password: '密碼',
        loading: '載入中',
        benefitsTitle: 'VIP權益',
        benefitsCondition: '首次儲值',
        benefitsItem1: '儲值返利',
        benefitsItem2: 'VIP專屬獎勵',
        benefitsItem3: '5%OFF每週折扣券(限時)',
        benefitsItem4: '10%OFF每週折扣券(限時)',
        vipInfoTitle: '說明',
        experienceTitle: '經驗獲取記錄',
        tableTitle1: '時間(UTC+0)',
        tableTitle2: '獲取途徑',
        tableTitle3: '經驗值',
        recordText1: '儲值中心儲值',
        recordText2: 'VIP等級重置',
        errorTips1: '登入失敗',
        errorTips2: '暫無記錄',
        htmlText1: '<p>1.您可以根據在官網儲值中心上購買的C Coin數量升級您的VIP等級。</p><p>2.VIP等級的獎勵C Coin和折扣券不能同時使用。獎勵的C Coin不能用於升級您的VIP等級。</p><p>3.根據您當時的VIP等級，折價券將於每週日（UTC）00:00發放。這些折扣券有效期至下週日（UTC）00:00。如果您在本週內升級您的VIP等級，您還將獲得該等級的折扣券。</p><p>4.首次購買折扣不能與獎勵C Coin或折扣券一起使用。首次購買折扣是預設情況下授予的。</p>',
        couponDescription4: '完成首次儲值',
    },
    en: {
        title: 'VIP CENTER',
        navLink: 'Topup Center',
        login: 'Log In',
        logout: 'Log Out',
        upgrade: 'UPGRADE',
        purchase: 'Purchase',
        upgradeVIP: 'Upgrade VIP',
        userLevel: 'Lv',
        userServer: 'Server',
        query: 'Query',
        email: 'E-mail',
        password: 'password',
        loading: 'LOADING',
        benefitsTitle: 'VIP Benefits',
        benefitsCondition: '1st Purchase',
        benefitsItem1: 'Purchase Rebate',
        benefitsItem2: 'VIP Exclusive Rewards',
        benefitsItem3: '5% Off Weekly Coupon(Limited Time)',
        benefitsItem4: '10% Off Weekly Coupon(Limited Time)',
        vipInfoTitle: 'Notes',
        experienceTitle: 'EXP Record',
        tableTitle1: 'Time(UTC+0)',
        tableTitle2: 'Way to Obtain',
        tableTitle3: 'EXP',
        recordText1: 'Purchase at Purchase Center',
        recordText2: 'Reset VIP Level',
        errorTips1: 'Login failed',
        errorTips2: 'There are currently no records available',
        htmlText1: '<p>1. You can upgrade your VIP level according to the amount of C Coins purchased in the official purchase center.</p><p>2. C Coins received from VIP level rewards cannot be used in combination with coupons. C Coin rewards also cannot be used to upgrade your VIP level.</p><p>3. According to your VIP level, coupons will be issued every Sunday at 00:00 (UTC). Coupons will be valid until the following Sunday at 00:00 (UTC). If you upgrade your VIP level during a week, you will receive coupons for your new VIP level the next Sunday.</p><p>4. First-purchase discounts cannot be used in combination with C Coin rewards or coupons. First-purchase discounts will be used by default.</p>',
        couponDescription4: 'Complete First Purchase',
    },
    de: {
        title: 'VIP',
        navLink: 'Topup Center',
        login: 'Anmelden',
        logout: 'Abbmelden',
        upgrade: 'Hochstufen',
        purchase: 'aufladen',
        upgradeVIP: 'VIP hochstufen',
        userLevel: 'Stufe',
        userServer: 'Server',
        query: 'Überprüfen',
        email: 'E-Mail',
        password: 'Passwort',
        loading: 'Laden',
        benefitsTitle: 'VIP-Vorteile',
        benefitsCondition: 'Erste Aufladung',
        benefitsItem1: 'Aufladungsrückgabe',
        benefitsItem2: 'VIP exklusive Belohnung',
        benefitsItem3: 'Wöchentlicher 5%-Rabatt-Gutschein(Zeitlich begrenzt)',
        benefitsItem4: 'Wöchentlicher 10%-Rabatt-Gutschein(Zeitlich begrenzt)',
        vipInfoTitle: 'Hinweis',
        experienceTitle: 'Wachstumspunkte-Verlauf',
        tableTitle1: 'Zeit(UTC+0)',
        tableTitle2: 'Methode',
        tableTitle3: 'Wachstumspunkt',
        recordText1: 'Käufe im Online-Laden',
        recordText2: 'Zurücksetzen der VIP-Stufe',
        errorTips1: 'Anmeldung fehlgeschlagen',
        errorTips2: 'Derzeit sind keine Datensätze verfügbar',
        htmlText1: '<p>1.Mit bestimmter Anzahl an die im Online-Laden gekauften C-Münzen können Sie Ihre VIP-Stufe hochstufen.</p><p>2.C-Münze, die durch VIP-Stufenbelohnung erhalten wurden, und Rabatt-Gutschein können nicht zusammen benutzt werden. Belohnungs-C-Münzen können nicht fürs Hochstufen der VIP-Stufe benutzt werden.</p><p>3.Je nach Ihre VIP-Stufe werden jeden Sonntag um 00:00 Uhr (UTC) Gutscheine ausgegeben. Die Gutscheine sind bis zum folgenden Sonntag um 00:00 Uhr (UTC) gültig. Wenn Sie Ihr VIP-Stufe während einer Woche erhöhen, erhalten Sie am nächsten Sonntag Gutscheine für Ihre neue VIP-Stufe.</p><p>4.Erstkaufrabatte können nicht in Kombination mit Belohnungs-C-Münzen oder Gutscheinen verwendet werden. Der Erstkauf-Rabatt wird standardmäßig verwendet.</p>',
        couponDescription4: 'Erste Aufladung abschließen',
    },
    fr: {
        title: 'Centre VIP',
        navLink: 'Topup Center',
        login: 'Se connecter',
        logout: 'Se déconnecter',
        upgrade: 'Mettre à niveau',
        purchase: 'Recharger',
        upgradeVIP: 'Mettre à niveau VIP',
        userLevel: 'Niveau',
        userServer: 'Serveur',
        query: 'Rechercher',
        email: 'E-mail',
        password: 'Mot de passe',
        loading: 'En chargement',
        benefitsTitle: 'Avantages VIP',
        benefitsCondition: 'Première recharge',
        benefitsItem1: 'Remise sur la recharge',
        benefitsItem2: 'Récompenses exclusives VIP',
        benefitsItem3: 'Coupon de réduction de 5 % chaque semaine (temps limité)',
        benefitsItem4: 'Coupon de réduction de 10 % chaque semaine (temps limité)',
        vipInfoTitle: 'Instructions',
        experienceTitle: "Historique des gains d'expérience",
        tableTitle1: 'Temps(UTC+0)',
        tableTitle2: "Source d'acquisition",
        tableTitle3: "Points d'expérience",
        recordText1: 'Recharge via le Centre de Recharge',
        recordText2: 'Réinitialisation du niveau VIP',
        errorTips1: 'La connexion a échoué',
        errorTips2: "Pas encore d'enregistrement",
        htmlText1: "<p>1.Vous pouvez mettre à niveau votre niveau VIP en fonction de la quantité de C Coin achetée sur le centre de recharge du site officiel.</p><p>2.Les C Coins et les coupons de réduction des niveaux VIP ne peuvent pas être utilisés en même temps. Les C Coins récompenses ne peuvent pas être utilisés pour mettre à niveau votre niveau VIP.</p><p>3.Selon votre niveau VIP actuel, les coupons de réduction seront distribués tous les dimanches à 00:00 (UTC). Ces coupons de réduction seront valables jusqu'au dimanche suivant à 00:00 (UTC). Si vous mettez à niveau votre niveau VIP au cours de la semaine, vous recevrez les coupons de réduction de ce niveau le dimanche de la même semaine.</p><p>4.Les remises sur la première recharge ne peuvent pas être utilisées avec les C Coins récompenses ou les coupons de réduction. Les remises sur la première recharge sont accordées par défaut.</p>",
        couponDescription4: 'Effectuer la première recharge',
    },
    tr: {
        title: 'VIP Merkezi',
        navLink: 'Topup Center',
        login: 'Giriş yap',
        logout: 'Çıkış yap',
        upgrade: 'Yükselt',
        purchase: 'Yükleme',
        upgradeVIP: 'VIP yükseltme',
        userLevel: 'Sv',
        userServer: 'Sunucu',
        query: 'Danışma',
        email: 'E-mail',
        password: 'parola',
        loading: 'Yüklenmek',
        benefitsTitle: 'VIP Hakları',
        benefitsCondition: 'İlk yükleme yapın',
        benefitsItem1: 'Yükleme İadesi',
        benefitsItem2: 'VIP Özel Ödüller',
        benefitsItem3: 'Her Hafta %5 İndirim Kuponu (Sınırlı Süreli)',
        benefitsItem4: 'Her Hafta %10 İndirim Kuponu (Sınırlı Süreli)',
        vipInfoTitle: 'Not',
        experienceTitle: 'Deneyim edinme kaydı',
        tableTitle1: 'Zaman(UTC+0)',
        tableTitle2: 'Erişim',
        tableTitle3: 'Deneyim puanları',
        recordText1: "Satın Alma Merkezi'nde satın alma",
        recordText2: 'VİP Seviyesini Sıfırlama',
        errorTips1: 'Giriş başarısız oldu',
        errorTips2: 'Şu anda kayıt yok',
        htmlText1: "<p>1.VIP seviyenizi resmi internet sitesindeki Yükleme Merkezi'nde satın aldığınız C Coin miktarına göre yükseltebilirsiniz.</p><p>2.VIP seviyesinin ödüllü C Coin ve indirim kuponları aynı anda kullanılamaz. Ödüllü C Coin, VIP seviyenizi yükseltmek için kullanılamaz.</p><p>3.Mevcut VIP seviyenize göre, indirim kuponları her Pazar (UTC) saat 00:00'de dağıtılır. Bu kuponlar, bir sonraki Pazar (UTC) saat 00:00'e kadar geçerlidir. Eğer mevcut hafta içinde VIP seviyenizi yükseltirseniz, bu seviyenin kuponlarını da alırsınız.</p><p>4.İlk satın alma indirimi, ödüllü C Coin veya indirim kuponları ile birlikte kullanılamaz. İlk satın alma indirimi varsayılan olarak verilir.</p>",
        couponDescription4: 'İlk yüklemeyi tamamlayın',
    },
    ru: {
        title: 'VIP-центр',
        navLink: 'Topup Center',
        login: 'Войти',
        logout: 'Выйти',
        upgrade: 'Повысить',
        purchase: 'Пополнить счет',
        upgradeVIP: 'Повысить VIP-уровень',
        userLevel: 'Уровень',
        userServer: 'Сервер',
        query: 'Поиск',
        email: 'Электронная почта',
        password: 'Пароль',
        loading: 'Загрузка',
        benefitsTitle: 'Преимущества VIP-статуса',
        benefitsCondition: 'Первое пополнение',
        benefitsItem1: 'Скидка на покупку',
        benefitsItem2: 'Эксклюзивные VIP-награды',
        benefitsItem3: 'Еженедельный купон со скидкой 5% (ограничено по времени)',
        benefitsItem4: 'Еженедельный купон со скидкой 10% (ограничено по времени)',
        vipInfoTitle: 'Описание',
        experienceTitle: 'Запись получения опыта',
        tableTitle1: 'Время(UTC+0)',
        tableTitle2: 'Как получить',
        tableTitle3: 'Опыт',
        recordText1: 'Покупка',
        recordText2: 'Сброс VIP-уровня',
        errorTips1: 'Ошибка регистрации',
        errorTips2: 'Нет записей',
        htmlText1: '<p>1.Вы можете повысить свой VIP-уровень в соответствии с количеством C Coin, которые вы приобрели в официальном центре пополнения счета.</p><p>2.C Coins, полученные от вознаграждений VIP-уровня, не могут быть использованы в сочетании с купонами и не могут повысить ваш VIP-уровень.</p><p>3.В соответствии с вашим VIP-уровнем, купоны будут выдаваться каждое воскресенье в 00:00 (UTC), которые действительны до 00:00 следующего воскресенья (UTC). Если вы повысите свой VIP-уровень в течение этой недели, вы также получите купоны на этот уровень в следующее воскресенье.</p><p>4.Скидка на первую покупку не может быть использована в сочетании с наградными C Coins или купонами. Скидка на первую покупку предоставляется по умолчанию.</p>',
        couponDescription4: 'Завершите первое пополнение',
    },
    id: {
        title: 'Pusat VIP',
        navLink: 'Topup Center',
        login: 'Log in',
        logout: 'Log out',
        upgrade: 'Tingkatkan',
        purchase: 'Topup',
        upgradeVIP: 'Meningkatkan VIP',
        userLevel: 'Lv',
        userServer: 'Server',
        query: 'Periksa',
        email: 'E-mail',
        password: 'sandi',
        loading: 'Memuatkan',
        benefitsTitle: 'Benefit VIP',
        benefitsCondition: 'Topup pertama kali',
        benefitsItem1: 'Rabat Topup',
        benefitsItem2: 'Hadiah eksklusif VIP',
        benefitsItem3: 'Kupon Diskon 5% Mingguan (Terbatas)',
        benefitsItem4: 'Kupon Diskon 10% Mingguan (Terbatas)',
        vipInfoTitle: 'Catatan',
        experienceTitle: 'Catatan Perolehan EXP',
        tableTitle1: 'Waktu(UTC+0)',
        tableTitle2: 'Cara Mendapatkan',
        tableTitle3: 'EXP',
        recordText1: 'Topup di Pusat Topup',
        recordText2: 'Reset Level VIP',
        errorTips1: 'Login gagal',
        errorTips2: 'Tidak ada catatan yang tersedia',
        htmlText1: '<p>1.Anda bisa meningkatkan level VIP berdasarkan jumlah C Coin yang Anda beli di pusat topup resmi.</p><p>2.C Coin yang didapatkan dari hadiah level VIP tidak bisa digunakan bersamaan dengan kupon. Hadiah C Coin tidak bisa digunakan untuk meningkatkan level VIP.</p><p>3.Berdasarkan level VIP anda, kupon akan dikirimkan setiap hari Minggu 00:00 (UTC). Kupon ini akan berlaku sampai hari Minggu selanjutnya 00:00 (UTC). Jika kamu meningkatkan level VIP dalam minggu ini, kamu juga akan mendapatkan kupon untuk level tersebut.</p><p>4.Diskon pembelian pertama tidak bisa digunakan bersamaan dengan kupon atau hadiah C Coin. Diskon pembelian pertama akan diberikan secara default.</p>',
        couponDescription4: 'Selesaikan Topup Pertama',
    },
    pt: {
        title: 'Centro de VIP',
        navLink: 'Topup Center',
        login: 'Iniciar sessão',
        logout: 'Terminar sessão',
        upgrade: 'Level Up',
        purchase: 'Recarga',
        upgradeVIP: 'Upgrade VIP',
        userLevel: 'Nv',
        userServer: 'Servidor',
        query: 'Pesquisa',
        email: 'E-mail',
        password: 'senha',
        loading: 'Carregamento',
        benefitsTitle: 'Direitos e benefícios de VIP',
        benefitsCondition: 'Recarga pela 1ª vez',
        benefitsItem1: 'Retorno de carga',
        benefitsItem2: 'Recompensas exclusivas para VIP',
        benefitsItem3: 'Cupom de desconto semanal de 5% OFF (tempo limitado)',
        benefitsItem4: 'Cupom de desconto semanal de 10% OFF (tempo limitado)',
        vipInfoTitle: 'Instruções',
        experienceTitle: 'Recorde de EXP',
        tableTitle1: 'Tempo(UTC+0)',
        tableTitle2: 'Maneiras de obter',
        tableTitle3: 'EXP',
        recordText1: 'Recarregar no Centro de Recarga',
        recordText2: 'Redefinir Nível de VIP',
        errorTips1: 'A autenticação falhou',
        errorTips2: 'Não existem actualmente registos disponíveis',
        htmlText1: '<p>1.Você pode atualizar seu nível VIP com base na quantidade de C Coin adquirida no centro de recarga do site oficial.</p><p>2.As C Coin de recompensa de nível VIP e  os cupons de desconto não podem ser usados ao mesmo tempo. As C Coins de recompensa não podem ser usadas para aumentar seu nível VIP.</p><p>3.Dependendo do seu nível VIP no momento, os cupons de desconto serão emitidos todos os domingos às 00:00 (UTC). Esses cupons de desconto são válidos até o domingo seguinte às 00:00 (UTC). Se você atualizar seu nível VIP durante a semana, também receberá um cupom de desconto para esse nível.</p><p>4.O desconto para quem compra pela primeira vez não pode ser usado em conjunto com a C Coin de recompensa ou com cupons de desconto. O desconto para quem compra pela primeira vez é concedido por padrão.</p>',
        couponDescription4: 'Concluir a Primeira Recarga',
    },
    jp: {
        title: 'VIPセンター',
        navLink: 'Topup Center',
        login: 'ログイン',
        logout: 'ログアウト',
        upgrade: 'グレードアップ',
        purchase: 'チャージ',
        upgradeVIP: 'VIPグレードアップ',
        userLevel: 'Lv',
        userServer: 'サーバー',
        query: 'EXPチェック',
        email: 'メールボックス',
        password: 'パスワード',
        loading: 'ロード中',
        benefitsTitle: 'VIP特典',
        benefitsCondition: '初回チャージ',
        benefitsItem1: 'チャージリベート',
        benefitsItem2: 'VIP限定特典',
        benefitsItem3: '週間5％オフクーポン（期間限定）',
        benefitsItem4: '週間10％オフクーポン（期間限定）',
        vipInfoTitle: '説明',
        experienceTitle: 'EXP獲得履歴',
        tableTitle1: '獲得時間(UTC+0)',
        tableTitle2: '獲得経由',
        tableTitle3: 'EXP',
        recordText1: 'チャージセンターでチャージする',
        recordText2: 'キングLv.をリセット',
        errorTips1: 'ログインに失敗しました',
        errorTips2: '記録はまだありません',
        htmlText1: '<p>1.公式チャージセンターで購入したC コインの量に応じて、VIPレベルをアップグレードすることができます。</p><p>2.VIPレベルの特典C コインと割引クーポンは同時に使用できません。報酬のC コインはVIPレベルのアップグレードには使用できません。</p><p>3.現在のVIPレベルに応じて、割引クーポンは毎週日曜日の00:00(UTC)に配布されます。これらのクーポンは、翌日曜日（UTC）の00:00まで有効です。その週にVIPレベルをアップグレードした場合、そのレベルに応じた割引クーポンも配布されます。</p><p>4.初回購入者割引は、特典C コインまたは割引クーポンとの併用はできません。 初回購入割引はデフォルトで付与されます。</p>',
        couponDescription4: '初回チャージを完了する',
    },
    ko: {
        title: 'VIP 센터',
        navLink: 'Topup Center',
        login: '로그인',
        logout: '로그아웃',
        upgrade: '레벨 업',
        purchase: '충전',
        upgradeVIP: 'VIP 레벨 업',
        userLevel: '레벨',
        userServer: '서버',
        query: '조회',
        email: '이메일',
        password: '암호',
        loading: '로드 중',
        benefitsTitle: 'VIP 특권',
        benefitsCondition: '첫 충전',
        benefitsItem1: '충전 리베이트',
        benefitsItem2: 'VIP 전용 보상',
        benefitsItem3: '5%OFF 매주 할인권(기간제)',
        benefitsItem4: '10%OFF 매주 할인권(기간제)',
        vipInfoTitle: '설명',
        experienceTitle: '경험치 획득 기록',
        tableTitle1: '시간(UTC+0)',
        tableTitle2: '획득 경로',
        tableTitle3: '경험치',
        recordText1: '충전 센터 충전',
        recordText2: 'VIP 레벨 초기화',
        errorTips1: '로그인 실패',
        errorTips2: '기록 없음',
        htmlText1: '<p>1.공식 충전 센터에서 구매한 C 코인 수량에 따라 VIP 레벨이 증가하게 됩니다.</p><p>2.VIP레벨 보상인 C 코인과 할인권은 동시에 사용할 수 없습니다. 보상으로 받은 C 코인은 VIP 레벨업에 사용할 수 없습니다.</p><p>3.현재 VIP 레벨에 따라, 할인권이 매주 일요일（UTC）00:00에 발송도비니다. 해당 할인권은 다음주 일요일（UTC）00:00까지 사용할 수 있습니다. 만약 이번주 내에 VIP 레벨을 상승시키면, 상응하는 할인권을 받을 수 있습니다.</p><p>4.첫 구매 할인과 보상으로 받은 C 코인 또는 할인권은 동시에 사용할 수 없습니다. 첫 구매시 할인은 기본적으로 부여됩니다.</p>',
        couponDescription4: '첫 충전 완료',
    },
}
export default messages_vip;